import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as outcomes from '../../outcome-external-sources'

export const RESOURCE = {
  payload: {
    description: 'TODO',
    dimension: outcomes.RESOURCE.payload,
    level: 0,
    name: 'Source',
    partialId: PartialId.Standard.create('source'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
